import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {MicrosoftAuth} from "../../Services/MicrosoftAuth";
import {GoogleAuth} from "../../Services/GoogleAuth";


import microsoftLogo from '../../Assets/Images/ms-symbollockup_mssymbol_19.png';
import {GoogleLogin, GoogleOAuthProvider} from "@react-oauth/google";

const LinkSignUp: React.FC = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const [linkIdentifier, setLinkIdentifier] = useState<string | null>(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const linkId = params.get('linkId');
        setLinkIdentifier(linkId); // Store the linkId for later use
    }, [location]);

    const { microsoftAccountLink, authError: microsoftAuthError } = MicrosoftAuth();
    const { googleAccountLink, authError: googleAuthError } = GoogleAuth();

    const [password, setPassword] = useState('');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const handlePasswordChange = (e: { target: { value: React.SetStateAction<string>; }; }) => setPassword(e.target.value);
    const togglePasswordVisible = () => setIsPasswordVisible(!isPasswordVisible);

    useEffect(() => {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn === 'true') {
            navigate('/account/profile');
        }
    }, [navigate]);

    // const handleSignUpWithPassword = async () => {
    //     const success = await microsoftAccountLink(linkIdentifier);
    //     if (success) {
    //         localStorage.setItem('isLoggedIn', 'true');
    //         navigate('/account/profile');
    //     } else {
    //         console.error('Microsoft login failed:', microsoftAuthError);
    //     }
    // };

    const handleMicrosoftLogin = async () => {
        const success = await microsoftAccountLink(linkIdentifier);
        if (success) {
            localStorage.setItem('isLoggedIn', 'true');
            navigate('/account/profile');
        } else {
            console.error('Microsoft login failed:', microsoftAuthError);
        }
    };

    return (
        <div className="signin-container">
            <div className="content-area">
                <h2 className="title">Link Account With</h2>

                <div className="signin-buttons">
                    <button className="signin-button" onClick={handleMicrosoftLogin}>
                        <img src={microsoftLogo} alt="teams logo"/>
                        <span>Sign In With Microsoft</span>
                    </button>

                    <div>
                        <GoogleOAuthProvider
                            clientId="932661471954-fcbfretcbo2hcf4iivmmfcqji9g08443.apps.googleusercontent.com">
                            <GoogleLogin
                                onSuccess={async (credentialResponse) => {
                                    const success = await googleAccountLink(credentialResponse, linkIdentifier);
                                    if (success) {
                                        localStorage.setItem('isLoggedIn', 'true');
                                        navigate('/account/profile');
                                    } else {
                                        console.error('Google login failed:', googleAuthError);
                                    }
                                }}
                                onError={() => console.error("Google login failed")}
                            />
                        </GoogleOAuthProvider>
                    </div>
                </div>

                {/*<div className="email-password-container">*/}
                {/*    <label>Password</label>*/}
                {/*    <div className="password-container">*/}
                {/*        <input type={isPasswordVisible ? 'text' : 'password'} placeholder="Enter your password"*/}
                {/*               value={password} onChange={handlePasswordChange}/>*/}
                {/*        <button className="show-password" onClick={togglePasswordVisible}>Show</button>*/}
                {/*    </div>*/}

                {/*    <button className="submit-button" onClick={handleSignUpWithPassword}>Link Account</button>*/}
                {/*</div>*/}
            </div>
        </div>
    );
};

export default LinkSignUp;
